import {useAppSelectorWithParam} from "../../../../redux/hooks";
import {getAssignedTicketStatForTeamMemberId} from "../../../../redux/team-members/team-members.selectors";


export const useTeamMemberAssignedTotalLogic = (teamMemberId: number): number => {
  const totalAssigned = useAppSelectorWithParam(getAssignedTicketStatForTeamMemberId, teamMemberId);
  return totalAssigned;
}
